export default function ErrorCircleIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2.00496 5.58378 5.58378 2.00496 10 2ZM13 14.483L14.483 13L11.483 10L14.483 7L13 5.517L10 8.517L7 5.517L5.517 7L8.517 10L5.517 13L7 14.483L10 11.483L13 14.483Z"
        fill="currentColor"
      />
    </svg>
  );
}
